export const theme = {
  colors: {
    primary: '#4A90E2', // Blue
    secondary: '#50E3C2', // Teal
    accent: '#F5A623', // Gold/Yellow
    success: '#7ED321', // Green
    danger: '#D0021B', // Red
    warning: '#F8E71C', // Yellow
    info: '#4A90E2', // Blue
    light: '#F8F9FA', // Light Gray
    dark: '#212529', // Dark Gray
    gray: '#8F9BB3', // Medium Gray
    background: '#FFFFFF', // White
    text: '#333333', // Dark Text
  },
  fonts: {
    body: "'Open Sans', sans-serif",
    heading: "'Montserrat', sans-serif",
  },
  fontSizes: {
    small: '0.875rem',
    medium: '1rem',
    large: '1.125rem',
    xlarge: '1.25rem',
    xxlarge: '1.5rem',
    xxxlarge: '2rem',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
  shadows: {
    small: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    medium: '0 3px 6px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.12)',
    large: '0 10px 20px rgba(0,0,0,0.15), 0 3px 6px rgba(0,0,0,0.10)',
  },
  radii: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%',
  },
} as const;

export type Theme = typeof theme; 